module.exports = __webpack_public_path__ + "static/bride-f042b4868d224582c6cf56d711243a6d.svg";